import { Textfield } from "@design-system/Inputs/Textfield";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Box } from "@design-system/Layout/Box";
import { FlexCol } from "@design-system/Layout/Flex";
import { HeaderFilter } from "@design-system/Table";
import { type ChangeEvent, type FC } from "react";
import { useSupplierTableTranslations } from "./i18n";

export const ProgressSelect: FC<{
    progress?: {
        min?: number;
        max?: number;
    };
    onProgressChange: (progress: { min?: number; max?: number }) => void;
}> = ({ progress, onProgressChange }) => {
    const { min = 0, max = 100 } = progress ?? {};
    const minValue = Number.isNaN(min) ? "" : min;
    const maxValue = Number.isNaN(max) ? "" : max;

    const handleMinChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value);

        if (value < 0 || value > 100) {
            return;
        }

        onProgressChange({
            min: value,
            max,
        });
    };

    const handleMaxChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value);

        if (value < 0 || value > 100) {
            return;
        }

        onProgressChange({
            min,
            max: value,
        });
    };

    const handleReset = () => {
        onProgressChange({
            min: 0,
            max: 100,
        });
    };

    const active =
        (!!minValue && minValue !== 0) || (!!maxValue && maxValue !== 100);

    const { t, keys } = useSupplierTableTranslations();

    return (
        <Dropdown onReset={handleReset}>
            <Dropdown.Trigger asChild>
                <HeaderFilter active={active}>
                    {t(keys.lastQuestionnaireProgress)}
                </HeaderFilter>
            </Dropdown.Trigger>
            <Dropdown.Content hasPortal>
                <FlexCol gap="2">
                    <Dropdown.Reset label={t(keys.reset)} />
                    <Box display="grid" gap="2" className="grid-cols-2">
                        <Textfield
                            type="number"
                            min={0}
                            max={100}
                            placeholder={t(keys.progress_min)}
                            value={minValue}
                            onChange={handleMinChange}
                        />
                        <Textfield
                            type="number"
                            min={0}
                            max={100}
                            placeholder={t(keys.progress_max)}
                            value={maxValue}
                            onChange={handleMaxChange}
                        />
                    </Box>
                </FlexCol>
            </Dropdown.Content>
        </Dropdown>
    );
};
